var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 47 47",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#e40089" },
        attrs: {
          d: "M6.2.1h34.7C44.3.1 47 2.8 47 6.2v34.6c0 3.4-2.7 6.1-6.1 6.1H6.2c-3.4 0-6.1-2.7-6.1-6.1V6.2C0 2.8 2.8.1 6.2.1z",
        },
      }),
      _c("defs", [
        _c("path", {
          attrs: {
            id: "a",
            d: "M6.2.1h34.7C44.3.1 47 2.8 47 6.2v34.6c0 3.4-2.7 6.1-6.1 6.1H6.2c-3.4 0-6.1-2.7-6.1-6.1V6.2C0 2.8 2.8.1 6.2.1z",
          },
        }),
      ]),
      _c("clipPath", { attrs: { id: "b" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#a" },
        }),
      ]),
      _c("path", {
        staticStyle: { "clip-path": "url(#b)", fill: "#ff45b4" },
        attrs: {
          d: "M26 11.4-.1 52.9C-1 54.3 0 56 1.5 56h54.1c1.6 0 2.6-1.8 1.7-3.1L29.4 11.4c-.8-1.2-2.6-1.2-3.4 0z",
        },
      }),
      _c("path", {
        staticStyle: { "clip-path": "url(#b)", fill: "#e40089" },
        attrs: {
          d: "M26.6 29 16.3 45.3c-.8 1.3.1 3.1 1.7 3.1h21.2c1.6 0 2.6-1.8 1.7-3.1L29.9 29c-.8-1.3-2.6-1.2-3.3 0z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }